<div class="sidebar-user__scroll">
  @for (invite of inviteList; track invite) {
    <ux-avatar
      class="sidebar-user__avatar"
      [active]="getInActive(invite.user)"
      [user]="invite.user"
      (click)="onFilterByUser(invite.user)"
    >
    </ux-avatar>
  }

  @if (isAdmin()) {
    <div class="sidebar-user__btn" (click)="onOpenSettings()">
      <i class="icon-plus"></i>
    </div>
  }
</div>
